"use strict";
angular.module('newspaperOrderModule', [
    'productManageMentOrderDeleteModule'
]).
controller('newspaperOrderCtrl', newspaperOrderCtrl);
newspaperOrderCtrl.$injector = ["$scope", "$state", "$filter", "$timeout", "$modal", "$location", "$stateParams", "trsHttpService", "modalDialog", "myManuscriptService", 'initSingleSelecet', 'editingCenterService', 'trsspliceString', "initVersionService", "productMangageMentNewspaperService", "getNewsNameService","$q"];

function newspaperOrderCtrl($scope, $state, $filter, $timeout, $modal, $location, $stateParams, trsHttpService, modalDialog, myManuscriptService, initSingleSelecet, editingCenterService, trsspliceString, initVersionService, productMangageMentNewspaperService, getNewsNameService,$q) {
    initStatus();
    initData();
    /**
     * [getSiteRights description]获取每个站点的操作权限
     * @return null [description]
     */
    function getSiteRights() {
        productMangageMentNewspaperService.getRight($stateParams.paper, "", "papersetpaper").then(function(data) {
            $scope.status.right = data;
        });
    }
    //根据类型筛选叠次
    $scope.queryByDieCiType = function() {
        initStatus();
        $scope.params.Status = angular.copy($scope.newspaperManageStateSelected).value;
        requestData();
    };
    //搜索叠次
    $scope.searchDieCi = function() {
        initStatus();
        $scope.params.CHNLNAME = $scope.keywords;
        requestData();
    };

    //初始化状态1234
    function initStatus() {
        $scope.params = {
            "serviceid": "mlf_paperset",
            "methodname": "queryDieCis",
            "PaperId": $stateParams.paper
        };
        $scope.status = {
            isTab: $location.path().split("/")[4],
            item: '',
            right: {},
            batchOperateBtn: {
                "hoverStatus": "",
                "clickStatus": ""
            },
        };
        $scope.selectedArray = [];
        getNewsNameService.getNewsName($stateParams.paper).then(function(data) {
            $scope.status.item = data;
            $scope.channelName = data.SITEDESC;
        });
        getSiteRights();
    }

    //初始化数据
    function initData() {
        requestData();
        getDropDown();

    }

    function requestData(params) {
        var deffer = $q.defer();
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), angular.isDefined(params) ? params : $scope.params, 'get').then(function(data) {
            $scope.items = data;
            $scope.page = data.PAGER;
            angular.isDefined($scope.page) ? $scope.page.PAGESIZE =
                $scope.page.PAGESIZE.toString() : $scope.page = {
                    "PAGESIZE": 0,
                    "ITEMCOUNT": 0
                };
            $scope.selectedArray = [];
            deffer.resolve();
        });
        return deffer.promise;
    }

    //全选
    $scope.selectAll = function() {

        $scope.selectedArray = $scope.selectedArray.length == $scope.items.length ? [] : [].concat($scope.items);
    };

    //单选
    $scope.selectDoc = function(item) {
        //item.selected ? $scope.selectedArray.push(item) : $scope.selectedArray.splice($scope.selectedArray.indexOf(item), 1);
        if ($scope.selectedArray.indexOf(item) < 0) {
            $scope.selectedArray.push(item);
        } else {
            $scope.selectedArray.splice($scope.selectedArray.indexOf(item), 1);
        }
    };

    function getDropDown() {
        //全部
        $scope.newspaperManageState = initSingleSelecet.newspaperManageState();
        $scope.newspaperManageStateSelected = angular.copy($scope.newspaperManageState[0]);

        //状态
        $scope.iWoDocStatus = initSingleSelecet.iWoReceiveDocStatus();
        $scope.iWoDocStatuSelected = angular.copy($scope.iWoDocStatus[0]);
        //下拉框单选结束
    }

    function share() {
        $scope.shareSelectedArray = angular.copy($scope.selectedArray);
        editingCenterService.share($scope, "mlf_myrelease", "receivedMyShare", function() {
            $scope.selectedArray = [];
            requestData();
        });
    }


    //编辑叠次信息
    $scope.modifyOrderInformation = function(item) {
        if ($scope.status.right.dieci.bianji) {
            $modal.open({
                templateUrl: "./manageConfig/productManageMent/newspaper/alertViews/modifyOrderInformation/modifyOrderInformation_tpl.html",
                scope: $scope,
                windowClass: 'man_produ_NewOrder',
                backdrop: false,
                controller: "productManageMentModifyOrderInfoCtrl",
                resolve: {
                    modifyOrderItem: function() {
                        return item;
                    }
                }
            }).result.then(function() {
                requestData();
            });
        } else {
            modalDialog.alertType("您没有权限编辑该叠次", "您没有权限编辑该叠次", "error", false);
        }
    };
    //新建叠次
    $scope.newOrder = function() {
        $modal.open({
            templateUrl: "./manageConfig/productManageMent/newspaper/alertViews/newOrder/newOrder_tpl.html",
            scope: $scope,
            windowClass: 'man_produ_NewOrder',
            backdrop: false,
            controller: "productManageMentNewOrderCtrl",
            resolve: {
                callback: function() {
                    return function(content) {
                        newOrderFun(0, content, $scope.params.PaperId);
                    };
                }
            }
        });
    };
    //新建叠次方法
    function newOrderFun(ObjectId, ChnlName, SiteId) {
        var params = {
            "serviceid": "mlf_paperset",
            "methodname": "saveDieCi",
            "ObjectId": ObjectId,
            "ChnlName": ChnlName,
            "SiteId": SiteId,
            "PaperId": $stateParams.paper
        };

        requestData(params).then(function(){
            requestData();
        });
    };
    //叠次排序
    $scope.orderRank = function(selectedArray, array) {
        var selection = selectedArray[0];
        for (var s = 0; s < array.length; s++) {
            if (selection.CHANNELID == array[s].CHANNELID) {
                var curP = s;
                break;
            }
        };
        $scope.list = {
            oldPosition: curP + 1,
            curItemName: selectedArray[0].CHNLDESC,
            allCounts: array.length,
            objId: selection.CHANNELID,
            objType: 101
        };
        productMangageMentNewspaperService.commOrder($scope.list, function() {
            var params = {
                "serviceid": "mlf_paperset",
                "methodname": "queryDieCis",
                "PaperId": $stateParams.paper
            };
            requestData(params);
        });
    };

    //批量删除
    $scope.orderDelete = function() {
        var SITEIDS = trsspliceString.spliceString($scope.selectedArray, 'CHANNELID', ',');
        modalDialog.confirmModal('提示信息', '确认删除?', function() {
            deleteItem(SITEIDS);
        });
        // $modal.open({
        //     templateUrl: "./manageConfig/productManageMent/newspaper/alertViews/orderDelete/orderDelete_tpl.html",
        //     scope: $scope,
        //     windowClass: 'zp-layout-deleted-window',
        //     backdrop: false,
        //     controller: "productManageMentOrderDeleteCtrl",
        //     resolve: {
        //         deleteItems: function() {
        //             return $scope.selectedArray;
        //         },
        //         callback: function() {
        //             return function(arrayDeleteitems) {
        //                 freshPager(arrayDeleteitems);
        //             }
        //         }

        //     }
        // });

    };
    //提交数据并刷新叠次页面
    // function freshPager(arrayDeleteitems) {
    //     $scope.params = {
    //         'serviceid': "mlf_paperset",
    //         'methodname': "deleteDieCiOrBanMians",
    //         "ObjectIds": arrayDeleteitems
    //     };
    //     trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, "post").then(function(data) {
    //         $scope.params = {
    //             "serviceid": "mlf_paperset",
    //             "methodname": "queryDieCis",
    //             "PaperId": $stateParams.paper
    //         };
    //         requestData();
    //     });

    // }
    //启用弹窗
    $scope.enableViews = function(CHANNELID, CHNLDESC) {
        modalDialog.confirmModal('提示信息', "确定启用？", function() {
            enableItem(CHANNELID);
        });
        // modalDialog.confirmModal('提示信息', '您确认启用：' + CHNLDESC, function() {
        //     enableItem(CHANNELID);
        // });
    };
    //启用方法
    function enableItem(CHANNELID) {
        var params = {
            "serviceid": "mlf_paperset",
            "methodname": "startDieCiOrBanMian",
            "ObjectId": CHANNELID,
            "PaperId": $stateParams.paper
        };
        requestData(params).then(function() {
            requestData();
        });
    };
    //停用弹窗
    $scope.disableViews = function(CHANNELID, CHNLDESC) {
        modalDialog.confirmModal('提示信息', "确定停用？", function() {
            disableItem(CHANNELID);
        });
        // modalDialog.confirmModal('提示信息', '您确认停用：' + CHNLDESC, function() {
        //     disableItem(CHANNELID);
        // });
    };
    //停用方法
    function disableItem(CHANNELID) {
        var params = {
            "serviceid": "mlf_paperset",
            "methodname": "stopDeiCiOrBanMian",
            "ObjectId": CHANNELID,
            "PaperId": $stateParams.paper
        };
        requestData(params).then(function() {
            requestData();
        });
    };
    //删除弹窗
    $scope.deleteViews = function(SITEID, CHNLDESC) {
        // console.log(SITEID);
        modalDialog.confirmModal('提示信息', '确认删除?', function() {
            deleteItem(SITEID);
        });
    };
    //删除方法
    function deleteItem(CHANNELID) {
        var params = {
            "serviceid": "mlf_paperset",
            "methodname": "deleteDieCiOrBanMians",
            "ObjectIds": CHANNELID,
            "PaperId": $stateParams.paper
        };
        requestData(params).then(function() {
            requestData();
        });
    }
}